import * as React from "react";
import {
  CurrentSnapshotCitationContext,
  type CurrentSnapshotCitation,
} from "@/modules/snapshots/contexts/useCurrentSnapshotCitation";

export const CurrentSnapshotCitationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentSnapshotCitation, setCurrentSnapshotCitation] = React.useState<CurrentSnapshotCitation | null>(null);

  const value = React.useMemo(
    () => ({ currentSnapshotCitation, setCurrentSnapshotCitation }),
    [currentSnapshotCitation],
  );

  return <CurrentSnapshotCitationContext.Provider value={value}>{children}</CurrentSnapshotCitationContext.Provider>;
};
